import { IExpertReportDecision } from 'containers/CourtManagerLegalProceedings/ExpertReport/typings';
import { DECISION } from 'containers/CourtManagerLegalProceedings/ExpertReport/constants';
import { useEffect, useState } from 'react';
import { PROCEDURE_STATUSES } from 'containers/data-structure';

export const useContestValidation = (decision: IExpertReportDecision) => {
  const [canValidate, setCanValidate] = useState<boolean>(false);

  let isValidated: boolean = !!decision[DECISION.DECISION];

  if (decision[DECISION.DECISION] === PROCEDURE_STATUSES.CONTESTED) {
    isValidated = isValidated && !!decision[DECISION.CONTEST_REASON];
  }
  if (decision[DECISION.DECISION] === PROCEDURE_STATUSES.REJECTED) {
    isValidated = isValidated && !!decision[DECISION.REJECTION_REASON];
  }

  useEffect(() => {
    setCanValidate(isValidated);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decision]);

  return [canValidate];
};
